__turbopack_context__.v({
  "button": "promotion-with-product-module-scss-module__PVUWeW__button",
  "content": "promotion-with-product-module-scss-module__PVUWeW__content",
  "discountLabel": "promotion-with-product-module-scss-module__PVUWeW__discountLabel",
  "icon": "promotion-with-product-module-scss-module__PVUWeW__icon",
  "iconLabel": "promotion-with-product-module-scss-module__PVUWeW__iconLabel",
  "iconWrapper": "promotion-with-product-module-scss-module__PVUWeW__iconWrapper",
  "message": "promotion-with-product-module-scss-module__PVUWeW__message",
  "root": "promotion-with-product-module-scss-module__PVUWeW__root",
  "title": "promotion-with-product-module-scss-module__PVUWeW__title",
});
